import Dexie from 'dexie';

export class DexieDb extends Dexie {
  // Declare implicit table properties.
  // (just to inform Typescript. Instanciated by Dexie in stores() method)
  positions!: Dexie.Table<PositionsDb, number>; // number = type of the primkey
  vessels!: Dexie.Table<VesselsDb, number>; // number = type of the primkey
  //...other tables goes here...

  constructor () {
      super("VesselsDb");
      this.version(1).stores({
          positions: 'imo', vessels: 'imoNo'
      });
  }
}

interface PositionsDb <T=any,Key=string> {}
interface VesselsDb <T=any,Key=string> {}
